module.exports = __webpack_public_path__ + "static/media/caretLeftTundora.00adaae9.svg";